_props$initialEntries